import { useState, Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

export default function Project({ proj }) {
  let [isOpen, setIsOpen] = useState(false);

  return (
    // hover:scale-110 cursor-pointer
    <div
      className="flex flex-col items-center bg-white m-12 md:p-16 p-4 pt-12 w-5/6 md:rounded-tl-full rounded-tr-lg md:rounded-br-full rounded-bl-lg relative shadow-xl"
    >
      <img
        src={proj.img}
        className="hover:scale-125   h-16 rounded-lg  absolute right-16 -top-5"
        onClick={() => setIsOpen(true)}
      />
      <h2 className="text-xl text-myBlue font-semibold font-headers ">{proj.title}</h2>
      <div className="py-4 md:px-12 px-4 md:mx-8 mx-2">{proj.discription}
      <br/>
      {proj.team}
      </div>
    
      <h2 className='text-darkBrown '>Tools</h2>
      <div className='flex md:flex-row flex-col'> 
        {proj.tools.map(tool => <button key={tool} className='bg-peach p-2 text-darkBrown md:m-4 m-2 rounded-lg'>{tool}</button>)}
        </div>
      <div className="">
        <button className="text-peach  bg-darkBrown hover:bg-darkBrown focus:ring-4 focus:ring-darkBrown font-medium rounded-full hover:scale-125 text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-darkBrown dark:hover:bg-darkBrown focus:outline-none dark:focus:ring-peach">
          <a href={proj.Demo} target="_blank" rel="noreferrer">
            Demo
          </a>
        </button>
        <button className="text-peach  bg-darkBrown hover:bg-darkBrown focus:ring-4 focus:ring-darkBrown font-medium rounded-full hover:scale-125 text-sm px-5 py-2.5 mr-2 mb-2 mx-8 dark:bg-darkBrown dark:hover:bg-darkBrown focus:outline-none dark:focus:ring-peach">
          <a href={proj.Code} target="_blank" rel="noreferrer">
            Code
          </a>
        </button>
      </div>
    </div>
  );
}
